/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Page Header
 */

import Container from 'react-bootstrap/Container';

// Components
import Slider from './Slider';
import NavBar from './Navbar';

const PageHeader = (props) => {
    const navbarLinks = props.navbar.links;
    const sliderItems = props.slider.sliderItems;

    return (
        <Container fluid>
            <NavBar links={navbarLinks} />
            <Slider items={sliderItems} />
        </Container>
    );
}
export default PageHeader;